import { createTrackingUtils } from "..";

const utils = createTrackingUtils({
  name: "flights_apex_web_remove_price_qualifier_for_solo_traveler_fd",
  stages: {
    main: 1, // solo traveler on FD page with ins or flex
    mdot: 2,
    ddot: 3,
    meta: 4,
    has_insurance: 5,
    has_flexibility: 6,
    has_ins_and_flex: 7
  },
  defaultStage: 1,
  goals: {}
});

interface TrackStagesParams {
  isMobile: boolean;
  isMeta: boolean;
  hasFlex: boolean;
  hasInsurance: boolean;
}

const trackStages = ({ isMobile, isMeta, hasFlex, hasInsurance }: TrackStagesParams) => {
  isMobile ? utils.stages.mdot() : utils.stages.ddot();
  if (isMeta) utils.stages.meta();
  if (hasInsurance) utils.stages.has_insurance();
  if (hasFlex) utils.stages.has_flexibility();
  if (hasFlex && hasInsurance) utils.stages.has_ins_and_flex();
};

export default { ...utils, trackStages };
